import React, { useState, useEffect } from 'react';
import styles from './editStagesModal.module.scss';
import { Container, Col, Modal, Button } from 'react-bootstrap';
import StageDetails from './stageDetails';
import Review from './review';
import CSSLoader from '../../../../shared/cssLoader';
import { CustomAlertBox } from '../../../../shared/customAlertBox';

const EditStagesModal = (props) => {


    let [step, setStep] = useState(1);
    let [values, setValues] = useState(props.singleStepValues);
    let [isLoading, setLoading] = useState(true);

    function nextPage(value) {
        setStep(value)
    }
    function previousPage(value) {
        setStep(value)
    }

    function updateInterviewValues(values) {
        setValues((prevState) => ({
            ...prevState,
            type_specific_parameters: {
                ...prevState.type_specific_parameters,
                minimum_pass_score: values.score,
                evaluation_criteria: values.vacancyDesc,
                interview_guidelines_to_candidate: values.guidelineDescription,
            }

        }))
    }

    function updateCVReviewValues(values) {
        setValues((prevState) => ({
            ...prevState,
            type_specific_parameters: {
                ...prevState.type_specific_parameters,
                number_of_reviewers_per_cv: values.numReviewer,
                reviewers: values.reviewers,
                minimum_pass_score: values.score,
                evaluation_criteria: values.vacancyDesc,
            }

        }))
    }

    function updateExternalAssessmentStepValues(values) {

        setValues((prevState) => ({
            ...prevState,
            assessment: values.assessment_body,
            type_specific_parameters: {
                ...prevState.type_specific_parameters,
                assessment_reviewers: values.assessment_reviewers,
                assessment_expire_in: values.assessment_expire_in,
                minimum_pass_score: values.score,
                evaluation_criteria: values.vacancyDesc,
            },

        }))
    }

    function updateCVFilterValues(values) {
        setValues((prevState) => ({
            ...prevState,
            keywords: values.keywords,
            keywordCount: values.keywordCount
        }))
    }

    function updateQuizstepValues(values) {

        setValues((prevState) => ({
            ...prevState,
            type_specific_parameters: {
                ...prevState.type_specific_parameters,
                quiz_template: values.quiz_template,
                quiz_expire_in: values.quiz_expire_in,
                minimum_pass_score: values.score,
            },


        }))
    }

    function updateReferenceCheckStepValues(values) {

        setValues((prevState) => ({
            ...prevState,
            type_specific_parameters: {
                ...prevState.type_specific_parameters,
                reference_check_reviewers: values.reference_check_reviewers,
                evaluation_criteria: values.vacancyDesc,

            },

        }))
    }

    function updateCustomEvaluationStepValues(values) {

        setValues((prevState) => ({
            ...prevState,
            type_specific_parameters: {
                ...prevState.type_specific_parameters,
                custom_evaluation_reviewers: values.custom_evaluation_reviewers,
                evaluation_criteria: values.vacancyDesc,
                minimum_pass_score: values.score,
                custom_evaluation_description: values.evaluationDescription,

            },

        }))
    }

    function updateOneWayInterviewStepValues(values) {

        setValues((prevState) => ({
            ...prevState,
            type_specific_parameters: {
                ...prevState.type_specific_parameters,
                one_way_interview_reviewers: values.one_way_interview_reviewers,
                evaluation_criteria: values.vacancyDesc,
                minimum_pass_score: values.score,
                expire_in: values.expire_in,
                one_way_interview_template: values.one_way_interview_template,

            },

        }))
    }


    useEffect(() => {
        async function setDefaultDropValues() {
            if (values.step_type_code === "CvReviewStep") {
                setLoading(true);
                let reviewersEmail = [];
                await (values.type_specific_parameters.reviewers).forEach(element => {
                    reviewersEmail.push({ label: element.email + ' - ' + element.name, value: element._id })
                });
                setValues((prevState) => ({
                    ...prevState,
                    type_specific_parameters: {
                        ...prevState.type_specific_parameters,
                        reviewers: reviewersEmail
                    }
                }))
                setLoading(false);
            } if (values.step_type_code === "ExternalAssessmentStep") {

                setLoading(true);
                let reviewersEmail = { label: values.type_specific_parameters.reviewers.email + ' - ' + values.type_specific_parameters.reviewers.name, value: values.type_specific_parameters.reviewers._id };

                setValues((prevState) => ({
                    ...prevState,
                    type_specific_parameters: {
                        ...prevState.type_specific_parameters,
                        assessment_reviewers: reviewersEmail
                    }
                }))
                setLoading(false);
            } if (values.step_type_code === "AutomatedCVFilterStep") {
                setLoading(true);
                let keyword_array = [];
                let keyword_count = values.type_specific_parameters.required_minimum_keyword_count;
                await (values.type_specific_parameters.keywords_to_scan).forEach(element => {
                    keyword_array.push(element.keyword);
                });
                setValues((prevState) => ({
                    ...prevState,
                    keywords: keyword_array,
                    keywordToBeAdded: '',
                    keywordCount: keyword_count
                }))
                setLoading(false);
            } if (values.step_type_code === "ReferenceCheckStep") {

                setLoading(true);
                let reviewersEmail = { label: values.type_specific_parameters.reviewers.email + ' - ' + values.type_specific_parameters.reviewers.name, value: values.type_specific_parameters.reviewers._id };

                setValues((prevState) => ({
                    ...prevState,
                    type_specific_parameters: {
                        ...prevState.type_specific_parameters,
                        reference_check_reviewers: reviewersEmail
                    }
                }))
                setLoading(false);
            } if (values.step_type_code === "CustomEvaluationStep") {

                setLoading(true);
                let reviewersEmail = { label: values.type_specific_parameters.reviewers.email + ' - ' + values.type_specific_parameters.reviewers.name, value: values.type_specific_parameters.reviewers._id };

                setValues((prevState) => ({
                    ...prevState,
                    type_specific_parameters: {
                        ...prevState.type_specific_parameters,
                        custom_evaluation_reviewers: reviewersEmail
                    }
                }))
                setLoading(false);
            } if (values.step_type_code === "OneWayInterviewStep") {

                setLoading(true);
                let reviewersEmail = { label: values.type_specific_parameters.reviewers.email + ' - ' + values.type_specific_parameters.reviewers.name, value: values.type_specific_parameters.reviewers._id };

                setValues((prevState) => ({
                    ...prevState,
                    type_specific_parameters: {
                        ...prevState.type_specific_parameters,
                        one_way_interview_reviewers: reviewersEmail
                    }
                }))
                setLoading(false);
            } else {
                setLoading(false);
            }
        }
        setDefaultDropValues();
    }, []);



    return (
        <div>
            <Modal
                show={props.showModal}
                onHide={props.handleClose}
                backdrop="static"
                keyboard={false}
                centered
                size="md"
            >
                <Modal.Body className={styles.modalBodyWrapper}>
                    <div className={styles.modalCancelBtnDiv}>
                        <Button className={styles.modalCancelBtn} onClick={props.handleClose}>
                            <svg width="24" height="24" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M13.5 4.5L4.5 13.5"  strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M4.5 4.5L13.5 13.5"  strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </Button>
                    </div>

                    <div className={styles.modalHeaderDiv}>
                        <h2 className={styles.modalHeader}>Edit Evaluation Step</h2>
                    </div>

                    <Col xs={{ span: 6, offset: 3 }} className={styles.stepPosition}>
                        <div className={step === 1 ? `${styles.roundStepMainDiv}` : step === 2 ? `${styles.roundStepMainDiv} ${styles.roundStepMainDiv2}` : `${styles.roundStepMainDiv}`}>
                            <div className={styles.stepActive}>1</div>
                            <div className={(step === 2) ? styles.stepActive : ''}>2</div>
                        </div>
                    </Col>

                    <Col xs={{ span: 10, offset: 1 }} className="mt-4">
                        <CustomAlertBox
                            alertBodyText="The changes will apply only to new candidates who are entering this step."
                            alertType="defaultAlert"
                        />
                    </Col>

                    <Col sm={12}  className={styles.colWithNoSidePaddings}>
                        <Container  className={styles.colWithNoSidePaddings}>
                            <p className={styles.stepSubtopicName}>
                                {
                                    step === 1 ? 'Step Configurations'
                                        : 'Review'
                                }
                            </p>
                            <hr className={styles.subTopicDivider} />
                        </Container>
                    </Col>

                    <Col sm={12} className={styles.colWithNoSidePaddings}>
                        {
                            isLoading === false ?
                                (<Container className={styles.colWithNoSidePaddings}>
                                    {/* Rendering Content Goes Here */}
                                    {step === 1 && props.showModal === true && <StageDetails nextPage={nextPage} values={values} updateCVReviewValues={updateCVReviewValues} updateInterviewValues={updateInterviewValues} updateExternalAssessmentStepValues={updateExternalAssessmentStepValues} updateCVFilterValues={updateCVFilterValues} updateQuizstepValues={updateQuizstepValues} updateReferenceCheckStepValues={updateReferenceCheckStepValues} updateCustomEvaluationStepValues={updateCustomEvaluationStepValues} updateOneWayInterviewStepValues={updateOneWayInterviewStepValues} />}
                                    {step === 2 && props.showModal === true && <Review nextPage={nextPage} previousPage={previousPage} handleClose={props.handleClose} getPipelineValues={props.getPipelineValues} values={values} />}
                                </Container>)
                                : (<div>
                                    <Col sm={{ span: 4, offset: 4 }}>
                                        <CSSLoader />
                                    </Col>
                                </div>)
                        }
                    </Col>
                </Modal.Body>
            </Modal>
        </div>
    )
}

export default EditStagesModal;
